import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FastBackward = function FastBackward(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21.9997 16.437c0 1.13 0 1.6951-.2283 1.9721a1 1 0 0 1-.8091.3633c-.3587-.0134-.781-.3888-1.6256-1.1395l-4.9917-4.4371c-.4653-.4136-.6979-.6204-.7836-.8646a1 1 0 0 1 0-.6625c.0857-.2442.3183-.451.7836-.8646l4.9917-4.437c.8446-.7508 1.2669-1.1262 1.6256-1.1396a1 1 0 0 1 .8091.3634c.2283.277.2283.842.2283 1.972zm-11 0c0 1.13 0 1.6951-.2283 1.9721a1 1 0 0 1-.8091.3633c-.3587-.0134-.781-.3888-1.6256-1.1395L3.345 13.1958c-.4653-.4136-.698-.6204-.7837-.8646a1 1 0 0 1 0-.6625c.0858-.2442.3184-.451.7837-.8646l4.9917-4.437c.8446-.7508 1.2669-1.1262 1.6256-1.1396a1 1 0 0 1 .8091.3634c.2283.277.2283.842.2283 1.972z"
    })
  }));
};
export default FastBackward;